import { useTranslation } from 'react-i18next';

import ModalConfirmation from '../../../../shared/ModalConfirmation/ModalConfirmation.jsx';
import { Modal } from '../../../boardSetup/components/Modals/Modal.jsx';
import usePrizeForm from './usePrizeForm';

export const DeletePrizeModal = ({ open, setOpen, prize }) => {
  const { t } = useTranslation('campaigns');
  const { handleDestroyPrize } = usePrizeForm({
    prizeValues: prize,
  });

  const onSave = () => {
    handleDestroyPrize(prize);
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <ModalConfirmation
        variant="error"
        onSave={() => onSave()}
        onCancel={() => setOpen(false)}
        header={t('prizes.deleteModal.title')}
        body={t('prizes.deleteModal.body')}
        cancelText={t('prizes.deleteModal.cancel')}
        submitText={t('prizes.deleteModal.delete')}
      />
    </Modal>
  );
};
